// Rulează căutarea automată de coperți pentru MAI MULTE cărți, în fundal (3 în paralel).
// Folosit din Setări (toată biblioteca) și din „Editare în grup” (cărțile selectate).
// Progresul e global: poți închide fereastra, bara de progres rămâne vizibilă jos.
import type { Work } from '../../shared/types';
import { autoCover, storeFromUrl, isLocalCover } from './covers';

export interface RunState { running: boolean; done: number; total: number; ok: number; fail: number; current?: string; label: string }
let state: RunState = { running: false, done: 0, total: 0, ok: 0, fail: 0, label: '' };
let stopFlag = false;
const listeners = new Set<() => void>();
const set = (p: Partial<RunState>) => { state = { ...state, ...p }; listeners.forEach(l => l()); };

export const coverRunner = {
  get state() { return state; },
  subscribe(fn: () => void) { listeners.add(fn); return () => listeners.delete(fn); },
  stop() { stopFlag = true; },

  // replace=false: doar cărțile fără copertă sau cu link extern (care se aduce „acasă”)
  // replace=true : caută o copertă nouă și pentru cele care au deja (o înlocuiește pe prima găsită)
  async start(works: Work[], opts: { replace: boolean; label: string }) {
    if (state.running) return;
    stopFlag = false;
    const queue = works.filter(w => opts.replace || !w.cover_url || !isLocalCover(w.cover_url));
    let done = 0, ok = 0, fail = 0;
    set({ running: true, done, total: queue.length, ok, fail, current: undefined, label: opts.label });
    const worker = async () => {
      while (queue.length && !stopFlag) {
        const w = queue.shift()!;
        set({ current: w.title });
        let success = false;
        if (!opts.replace && w.cover_url && !isLocalCover(w.cover_url)) {
          try { await storeFromUrl(w.id, w.cover_url, 'legacy'); success = true; } catch { /* link mort → căutăm alta */ }
        }
        if (!success) { try { success = (await autoCover(w)).ok; } catch { success = false; } }
        success ? ok++ : fail++;
        done++;
        set({ done, ok, fail });
      }
    };
    await Promise.all([worker(), worker(), worker()]);
    set({ running: false, current: undefined });
    return { ok, fail, stopped: stopFlag };
  }
};
